
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[authorID]/about",
      function () {
        return require("private-next-pages/[authorID]/about.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[authorID]/about"])
      });
    }
  